// 获取路径数组
export const getPath = (path: string) => {
  const pathList: string[] = [];
  path.replace(/(\/[^\/]*)/g, (match) => {
    pathList.push(match);
  });
  return pathList;
};
